import React, { Component } from "react";
import { connect } from "react-redux";
//
import Screen from "./ConnectedScreen";
import FormField from "../components/FormField";
import MarketingAlert from "../components/MarketingAlert";

class LoginScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
    };
  }

  onChange(name, value) {
    this.setState({
      [name]: value,
    });
  }

  enterSubmit(ev) {
    if (ev.key === "Enter") {
      this.login();
    }
  }

  login() {
    const { email, password } = this.state;
    const { login } = this.props;

    login(email, password);
  }

  render() {
    const { errors, errorMessage, isLoading } = this.props;
    const { email, password } = this.state;

    return (
      <Screen
        title="Login"
        isActive
        onNext={(ev) => this.login()}
        nextLabel={isLoading ? "Please wait..." : "Login"}
        nextDisabled={isLoading}
      >
        <form className="form u-mb">
          <FormField
            label="Email"
            type="email"
            placeholder="Your email"
            onChange={(ev) => this.onChange("email", ev.target.value)}
            onKeyDown={(ev) => this.enterSubmit(ev)}
            error={errors["email"]}
            value={email}
            isSensitive
            autoFocus
          />
          <FormField
            label="Password"
            type="password"
            placeholder="Your password"
            onChange={(ev) => this.onChange("password", ev.target.value)}
            error={errors["password"]}
            value={password}
            onKeyDown={(ev) => this.enterSubmit(ev)}
          />
        </form>
        {errorMessage !== null && (
          <p
            className="u-danger u-mt"
            dangerouslySetInnerHTML={{ __html: errorMessage }}
          />
        )}
        <MarketingAlert />
      </Screen>
    );
  }
}

// @connect
import { loginAction } from "../modules/auth";

function mapState(state) {
  const { auth } = state;

  return {
    errors: auth.errors,
  };
}

function mapDispatch(dispatch) {
  return {
    login(email, password) {
      dispatch(loginAction(email, password));
    },
  };
}

export default connect(
  mapState,
  mapDispatch
)(LoginScreen);
